import { findValidFieldId } from "./findValidFieldId";

const key = "add-unknown-engine";

const applicable = (resp) => {
	return resp.config.url.match(/api\/forms\/[0-9]*$/);
};

const ruleJson = (validFieldId) => ({
	"Id": 1,
	"Title": "Unknown Engine",
	"Operator":
	{
		"Id": 2,
		"Code": "OR",
		"Name": "Or"
	},
	"Engine":
	{
		"Id": 1,
		"Code": "RANDOM-UNKNOWN",
		"Name": "NotKnown"
	},
	"Conditions":
	[
		{
			"Id": 1,
			"Field":
			{
				"Id": validFieldId
			}
		}
	],
	"Triggers":
	[
		{
			"Operator":
			{
				"Id": 1,
				"Code": "BLOCKSAVE",
				"Name": "Block Saving"
			},
			"Type":
			{
				"Id": 1,
				"Code": "VALIDATION",
				"Name": "Validation"
			}
		}
	]
});

const modify = (resp) => {
	if(!resp.data.Data?.Rules) {
		return;
	}

	const ruleWithUnknownEngine = ruleJson(findValidFieldId(resp.data.Data));
	resp.data.Data.Rules.push(ruleWithUnknownEngine);
};

export const addUnknownEngine = [key, applicable, modify];